import { getModuleList, getTableList, deleteDeepLink, save, incrScannedTimes } from '@/axios/api/deeplink'
import {
  getTrend,
  getFormulationList,
  getBasfProduct,
  getConceptList,
  getEventList,
  getWebinar
} from '@/axios/api/appPictures'
const UPDATE_MODULE_LIST = 'UPDATE_MODULE_LIST'
const UPDATE_TOTAL = 'UPDATE_TOTAL'
const UPDATE_SEARCH = 'UPDATE_SEARCH'
const UPDATE_TABLEDATA = 'UPDATE_TABLEDATA'
const UPDATE_TBL_LOADING = 'UPDATE_TBL_LOADING'

const state = {
  moduleList: [],
  params: {
    moduleNumber: '',
    creator: '',
    remarks: '',
    utmSource: '',
    date: []
  },
  pager: {
    current: 1,
    size: 10,
    total: 0
  },
  tableData: [],
  tblLoading: false
}
const getters = {
  moduleList: state => state.moduleList,
  params: state => state.params,
  pager: state => state.pager,
  tableData: state => state.tableData,
  tblLoading: state => state.tblLoading
}
const mutations = {
  [UPDATE_MODULE_LIST] (state, moduleList) {
    state.moduleList = moduleList || []
  },
  [UPDATE_TOTAL] (state, total) {
    state.pager = { ...state.pager, total }
  },
  [UPDATE_SEARCH] (state, { pager, params }) {
    state.pager = { ...state.pager, ...pager }
    if (params) state.params = params
  },
  [UPDATE_TABLEDATA] (state, tableData) {
    state.tableData = tableData
  },
  [UPDATE_TBL_LOADING] (state, tblLoading) {
    state.tblLoading = tblLoading
  }
}

const actions = {
  // 设置page
  setPagerApi ({ commit }, pager) {
    commit(UPDATE_SEARCH, { pager })
  },
  async getModuleListApi ({ commit }, params) {
    try {
      const { data: res } = await getModuleList(params)
      commit(UPDATE_MODULE_LIST, res || [])
    } catch (e) { }
  },
  async getTableListApi ({ commit }, params) {
    try {
      commit(UPDATE_TBL_LOADING, true)
      let { data: res } = await getTableList(params)
      commit(UPDATE_TBL_LOADING, false)
      commit(UPDATE_TABLEDATA, res.records)
      commit(UPDATE_TOTAL, res.total)
    } catch (e) {
      commit(UPDATE_TBL_LOADING, false)
    }
  },
  async deleteDeepLinkApi ({ commit }, params) {
    try {
      const res = await deleteDeepLink(params)
      return res && res.errorCode === 200
    } catch (e) { }
  },
  // 获取各个模块二级下拉列表
  async getPageListApi ({commit}, { moduleId, keyword }) {
    try {
      const res = await getPageListFn[moduleId]({ keyword, size: 10 })
      return res || []
    } catch (e) {
      return false
    }
  },
  async saveApi ({commit}, params) {
    try {
      const res = await save(params)
      return res && res.errorCode === 200
    } catch (e) {
      return false
    }
  },
  // 增加扫描次数
  async incrScannedTimesApi ({ commit }, params) {
    try {
      await incrScannedTimes(params)
    } catch (e) {}
  }
}
const getPageListFn = {
  263: async function (params) {
    try {
      const { data } = await getTrend(params)
      return data.map(value => {
        return {
          value: value.id,
          label: value.title
        }
      })
    } catch (e) {
      return []
    }
  },
  271: async function (params) {
    try {
      const { data } = await getBasfProduct({
        tradeName: params.keyword,
        size: 10
      })
      return data.records.map(value => {
        return {
          value: value.id,
          label: value.tradeName
        }
      })
    } catch (e) {
      return []
    }
  },
  266: async function (params) {
    try {
      const { data } = await getFormulationList(params)
      return data.list.map(value => {
        return {
          value: value.id,
          label: value.title
        }
      })
    } catch (e) {
      return []
    }
  },
  264: async function (params) {
    try {
      const { data } = await getConceptList(params)
      return data.map(value => {
        return {
          value: value.id,
          label: value.internationalTitle
        }
      })
    } catch (e) {
      return []
    }
  },
  290: async function (params) {
    try {
      const { data } = await getWebinar(params)
      return data.map(value => {
        return {
          value: value.id,
          label: value.title
        }
      })
    } catch (e) {
      return []
    }
  },
  291: async function (params) {
    try {
      const { data } = await getEventList(params)
      return data.map(value => {
        return {
          value: value.id,
          label: value.eventName
        }
      })
    } catch (e) {
      return []
    }
  }
}
export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/deeplink.js